import type { CSSProperties, ReactNode } from 'react';

export interface FieldListItem {
  /** Uppercase micro-label. Use the real field or column name where the operator needs to match it. */
  label: string;
  /** null / '' renders an em dash in muted ink. */
  value?: ReactNode;
  /** Mono + tabular + LTR: IDs, numbers, phones, timestamps. */
  mono?: boolean;
}

const isEmpty = (value: ReactNode) => value === null || value === undefined || value === '';

/** Label/value inspector with hairline rules (detail dialogs). */
export function FieldList({ fields, style }: { fields: FieldListItem[]; style?: CSSProperties }) {
  return (
    <dl className="fs-fieldlist" style={style}>
      {fields.map((field) => (
        <div key={field.label} className="fs-fieldlist__row">
          <dt className="fs-fieldlist__label">{field.label}</dt>
          <dd
            className={[
              'fs-fieldlist__value',
              field.mono && 'fs-fieldlist__value--mono',
              isEmpty(field.value) && 'fs-fieldlist__value--empty',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {isEmpty(field.value) ? '—' : field.mono ? <bdi dir="ltr">{field.value}</bdi> : field.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
